import { __extends, __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames, analyticsTracker, validatePropType } from 'uitk-react-utils';
import styles from './uitk-button.css';

var getClassNameList = classNames.bind(styles);
var UitkButtonSize;
(function (UitkButtonSize) {
    UitkButtonSize["SMALL"] = "small";
    UitkButtonSize["MEDIUM"] = "medium";
    UitkButtonSize["LARGE"] = "large";
})(UitkButtonSize || (UitkButtonSize = {}));
var UitkButtonTheme;
(function (UitkButtonTheme) {
    UitkButtonTheme["SOLID"] = "solid-btn";
    UitkButtonTheme["TRANSPARENT"] = "transparent-btn";
})(UitkButtonTheme || (UitkButtonTheme = {}));
var UitkButton = /** @class */ (function (_super) {
    __extends(UitkButton, _super);
    function UitkButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkButton.prototype.render = function () {
        var _a, _b;
        var href = this.props.href;
        var _c = this.props, analytics = _c.analytics, children = _c.children, className = _c.className, domRef = _c.domRef, isFullWidth = _c.isFullWidth, size = _c.size, tag = _c.tag, attributes = __rest(_c, ["analytics", "children", "className", "domRef", "isFullWidth", "size", "tag"]);
        var Tag = tag || (href ? 'a' : 'button');
        var newChildren = [];
        var buttonProps = __assign({}, attributes);
        if (Tag === 'button' && !buttonProps.type) {
            buttonProps.type = 'button';
        }
        // Enable :active css state on touch devices.
        // https://css-tricks.com/snippets/css/remove-gray-highlight-when-tapping-links-in-mobile-safari/
        if (!buttonProps.onTouchStart) {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            buttonProps.onTouchStart = function () { };
        }
        var childrenCount = React.Children.toArray(children).length;
        var badge;
        var trailingIcon;
        var leadingIcon;
        var buttonText;
        var a11yText;
        var ariaLabel = attributes['aria-label'];
        React.Children.forEach(children, function (child, index) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
            var existingClassName = (_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.className;
            a11yText = ((_b = child === null || child === void 0 ? void 0 : child.props) === null || _b === void 0 ? void 0 : _b['data-a11ytext']) === 'true';
            if (((_d = (_c = child === null || child === void 0 ? void 0 : child.type) === null || _c === void 0 ? void 0 : _c.displayName) === null || _d === void 0 ? void 0 : _d.includes('UitkNotificationBadge')) ||
                ((_f = (_e = child === null || child === void 0 ? void 0 : child.type) === null || _e === void 0 ? void 0 : _e.displayName) === null || _f === void 0 ? void 0 : _f.includes('UitkBadgeNotification'))) {
                var badgeLabel = '';
                if (((_g = child === null || child === void 0 ? void 0 : child.props) === null || _g === void 0 ? void 0 : _g.children) && typeof ((_h = child === null || child === void 0 ? void 0 : child.props) === null || _h === void 0 ? void 0 : _h.children) === 'string')
                    badgeLabel = [(_j = child === null || child === void 0 ? void 0 : child.props) === null || _j === void 0 ? void 0 : _j.a11yText, (_k = child === null || child === void 0 ? void 0 : child.props) === null || _k === void 0 ? void 0 : _k.children, (_l = child === null || child === void 0 ? void 0 : child.props) === null || _l === void 0 ? void 0 : _l.count]
                        .filter(function (text) { return !!text; })
                        .join();
                if (!ariaLabel && badgeLabel.length)
                    ariaLabel = [buttonText, badgeLabel].filter(function (text) { return !!text; }).join();
                badge = React.cloneElement(child, {
                    className: 'uitk-button-notification-badge'
                });
            }
            else if (((_m = child === null || child === void 0 ? void 0 : child.type) === null || _m === void 0 ? void 0 : _m.displayName) === 'UitkIcon' || ((_o = child === null || child === void 0 ? void 0 : child.type) === null || _o === void 0 ? void 0 : _o.displayName) === 'LodgingEGDSIcon') {
                leadingIcon =
                    !leadingIcon && index === 0
                        ? React.cloneElement(child, { className: getClassNameList(existingClassName, 'uitk-icon-leading') })
                        : leadingIcon;
                trailingIcon =
                    !trailingIcon && index !== 0 && index + 1 === childrenCount
                        ? React.cloneElement(child, { className: getClassNameList(existingClassName, 'uitk-icon-trailing') })
                        : trailingIcon;
            }
            else if (typeof child === 'string' || (typeof ((_p = child === null || child === void 0 ? void 0 : child.props) === null || _p === void 0 ? void 0 : _p.children) === 'string' && !a11yText)) {
                buttonText = buttonText || child;
            }
            else {
                newChildren.push(child);
            }
        });
        if (!buttonProps.onClickCapture && analytics) {
            buttonProps.onClickCapture = analyticsTracker.bind(this, analytics);
        }
        var hasIcon = leadingIcon || trailingIcon;
        var onlyIcon = (hasIcon && childrenCount === 1) || (hasIcon && a11yText && childrenCount === 2);
        var wrapperClassNames = getClassNameList(UitkButton.baseClassName, (_a = {},
            _a["".concat(UitkButton.baseClassName, "-").concat(size)] = validatePropType(size, UitkButtonSize),
            _a), (_b = {},
            _b["".concat(UitkButton.baseClassName, "-fullWidth")] = isFullWidth,
            _b["".concat(UitkButton.baseClassName, "-has-text")] = buttonText,
            _b["".concat(UitkButton.baseClassName, "-only-icon")] = onlyIcon,
            _b["".concat(UitkButton.baseClassName, "-as-link")] = href,
            _b), className);
        if (!(ariaLabel === null || ariaLabel === void 0 ? void 0 : ariaLabel.length) || ariaLabel === buttonText)
            ariaLabel = undefined;
        return (React.createElement(Tag, __assign({}, buttonProps, { className: wrapperClassNames, ref: domRef, "aria-label": ariaLabel }),
            badge && !(trailingIcon || leadingIcon) && badge,
            leadingIcon,
            buttonText,
            newChildren,
            trailingIcon));
    };
    UitkButton.displayName = 'UitkButton';
    UitkButton.defaultProps = {
        isFullWidth: false,
        size: UitkButtonSize.MEDIUM
    };
    UitkButton.baseClassName = 'uitk-button';
    return UitkButton;
}(React.Component));

export { UitkButton, UitkButtonSize, UitkButtonTheme };
